<!-- 选择登录账号-弹窗 -->
<template>
  <a-modal
    v-model="visible"
    wrapClassName="choose_login_account_dialog"
    style="top: 20vh"
    :width="480"
    :maskClosable="false"
    :afterClose="afterClose"
  >
    <template slot="title">
      <div class="modal_title">
        <h3>请选择指定账号登录</h3>
        <p>你的手机号关联多个账号，请选择其中一个登录</p>
      </div>
    </template>

    <a-spin :spinning="dialogLoading">
      <ul class="list_wrapper">
        <li
          v-for="(item, index) in accountList"
          class="list_item"
          :key="index"
          @click="handleChoose(item)"
        >
          <div class="avatar">
            <img src="@/assets/images/userIcon.png" class="img" alt="" />
          </div>
          <div class="item_right">
            <div class="title">
              <h3 class="text_overflow">{{ item.companyName }}</h3>
              <span v-if="item.isRecentLogin">上次登录</span>
            </div>
            <div class="sub_title">
              {{ item.roleName }}
              <span class="name">({{ item.userName }})</span>
            </div>
          </div>
        </li>
      </ul>
    </a-spin>

    <template slot="footer">
      <a-button @click="close">取 消</a-button>
    </template>
  </a-modal>
</template>

<script>
export default {
  name: 'chooseLoginAccountModal',
  emits: ['afterClose', 'choose', 'cancel'],
  props: {},
  data() {
    return {
      visible: false,
      dialogLoading: false,
      userAccountList: []
    }
  },
  computed: {
    accountList() {
      if (!this.userAccountList || !this.userAccountList.length) return []
      const list = [...this.userAccountList]
      // const index = findRecentLoginIndex(list)
      // if (index !== -1) {
      //   // 将最近登录的角色置顶
      //   const recentItem = list.splice(index, 1)[0]
      //   recentItem.isRecentLogin = true
      //   list.unshift(recentItem)
      // }
      return list
    }
  },
  methods: {
    /**
     * 确认
     */
    async handleChoose(item) {
      this.$emit('choose', item)
      this.close()
    },

    /**
     * 找到最近登录的角色下标
     */
    findRecentLoginIndex(list) {
      let index = -1
      const recentLoginData = Local.get(localKeys.RECENT_LOGIN)
      if (recentLoginData) {
        index = list.findIndex(
          item =>
            item.companyId === recentLoginData.companyId &&
            item.roleId === recentLoginData.roleId &&
            item.userName === recentLoginData.userName
        )
      }
      return index
    },

    /**
     * 重置数据
     */
    afterClose() {
      this.userAccountList = []
      this.$emit('afterClose')
    },

    /**
     * 打开弹窗
     */
    open(list) {
      if (!list || !list.length) return
      if (this.visible) return
      this.visible = true
      this.userAccountList = list
    },

    /**
     * 关闭弹窗
     */
    close() {
      if (!this.visible) return
      this.visible = false
    }
  },

  mounted() {},

  beforeDestroy() {}
}
</script>

<style lang="scss" scoped>
.modal_title {
  margin-bottom: 12px;
  h3 {
    font-size: 18px;
  }
  p {
    font-size: 14px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.45);
    line-height: 16px;
    margin-top: 7px;
  }
}

.list_wrapper {
  padding: 14px 0;
  .list_item {
    display: flex;
    align-items: center;
    padding: 16px;
    background: rgba(0, 0, 0, 0.03);
    border-radius: 2px;
    margin-bottom: 14px;
    cursor: pointer;
    &:last-child {
      margin-bottom: 0;
    }
    &:hover {
      background: rgba(0, 0, 0, 0.05);
    }
    .avatar {
      width: 48px;
      height: 48px;
      margin-right: 12px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 50%;
      }
    }
    .item_right {
      flex: 1;
      overflow: hidden;
      .title {
        display: flex;
        align-items: center;
        h3 {
          font-size: 16px;
          color: #000;
          line-height: 22px;
          flex: 1;
          overflow: hidden;
          margin-bottom: 4px;
        }
        span {
          font-size: 14px;
          font-weight: 400;
          color: #fff;
          line-height: 20px;
          padding: 2px 8px;
          background: #1890ff;
          border-radius: 2px;
          margin-left: 12px;
        }
      }
      .sub_title {
        font-size: 14px;
        line-height: 22px;
      }
      .name {
        color: #999;
      }
    }
  }
}
</style>

<style lang="scss">
.choose_login_account_dialog {
  .ant-modal-content {
    border-radius: 2px;
    padding: 0;
  }
  .ant-modal-header {
    padding: 20px 20px 0;
  }
  .ant-modal-body {
    padding: 0 20px;
    max-height: 310px;
    overflow-y: auto;
  }
}
</style>
